import React, { useEffect, useState } from "react";
import Get from "../services/Get";
import { Button, Row, Spin } from "antd";
import { useNavigate } from "react-router-dom";

const Insurance = () => {
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(true);

  const navigate = useNavigate();

  const getUrl = () => {
    Get.getInsuranceUrl()
      .then((res) => {
        console.log("url", res);
        setUrl(res.url);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <>
      <Row justify={"end"} style={{marginBottom: 14, marginRight: 14}}>
        <Button
          className="form-btn"
          onClick={() => navigate("/user/insurance-history")}
        >
          View History
        </Button>
      </Row>
      <div style={{ backgroundColor: "#f5f5f5", minHeight: "100vh" }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <Spin size="large" />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <iframe
              src={url}
              title="Insurance"
              width="100%"
              height="100%"
              style={{ border: "1px solid #ccc" }}
            ></iframe>
          </div>
        )}
      </div>
    </>
  );
};

export default Insurance;
